import type { ReactNode } from 'react'

import type { CautionVariant } from './styles'
import { CautionBox, CautionHeader, CautionIcon, CautionItemWrap, CautionTitle } from './styles'

interface CautionItemProps {
  variant: CautionVariant
  icon: string
  title: string
  children: ReactNode
}

export function CautionItem({ variant, icon, title, children }: CautionItemProps) {
  return (
    <CautionItemWrap>
      <CautionHeader>
        <CautionIcon
          src={icon}
          alt=''
        />
        <CautionTitle variant={variant}>{title}</CautionTitle>
      </CautionHeader>
      <CautionBox variant={variant}>{children}</CautionBox>
    </CautionItemWrap>
  )
}
